import { GenericServiceResponse } from './generic-service-response';
import { UIInfo } from '../domain-models/ui-finder/ui-info';
import { ResponseResultTypeDecorator } from './decorators/response-result-type.decorator';

@ResponseResultTypeDecorator(UIInfo)
export class FindUIInfoResponse extends GenericServiceResponse<UIInfo> {


}
